module.exports = __webpack_public_path__ + "img/LaMeuseDragLocation.c1fb0e6a.svg";